(function() {
  var myVar = setInterval(timer, 300);
  function timer() {
    if (window.jQuery) {
      $(document).ready(function() {
        $(document).on("swell:setup", function() {
          $(".swell-post-checkout").css("display", "flex");
          SwellConfig.Faq.initializeFaqs(".swell-question-button, .swell-question-list");
          $(".swell-post-checkout .swell-referral-back-link").click(function() {
            $(".swell-post-checkout").hide();
          });
        });
      });
      stop();
    }
  }
  function stop() {
    clearInterval(myVar);
  }


  (function() {
    window.SwellConfig = window.SwellConfig || {};

    SwellConfig.Faq = {
      initializeFaqs: function(containerSelector) {
        var collapsed_text, expanded_text;
        expanded_text = "Show Less <i class=\"fa fa-chevron-up\" aria-hidden=\"true\"></i>";
        collapsed_text = "Show All FAQs <i class=\"fa fa-chevron-down\" aria-hidden=\"true\"></i>";
        return $(containerSelector).click(function(e) {
          var $swell_question_list;
          if ($(e.target).is(containerSelector)) {
            $swell_question_list = $(".swell-question-list");
            $swell_question_list.toggleClass("swell-question-list-expanded");
            return $(".swell-question-button").html($swell_question_list.hasClass("swell-question-list-expanded") ? expanded_text : collapsed_text);
          }
        });
      }
    };
  }).call(this);

  (function() {
    var classNames, selectors,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

    classNames = {
      container: "swell-question-content",
      heading: "swell-question-heading",
      section: "swell-question-details",
      open: "swell-question-open"
    };

    selectors = {
      container: "." + classNames.container,
      heading: "." + classNames.heading,
      section: "." + classNames.section,
      open: "." + classNames.open
    };

    $(document).ready(function() {
      var hash, heading, openCollapsiblesForAnchor, toHide;
      openCollapsiblesForAnchor = function(hash, redirect) {
        var anchors, el, name;
        name = hash.substr(1);
        anchors = $(selectors.container).find(hash + ", a[name=\"" + name + "\"]");
        if (anchors.length > 0) {
          el = $(anchors[0]);
          el.closest(selectors.container).find(selectors.heading).click();
          return el.closest(selectors.section).promise().done(function() {
            return window.location = redirect;
          });
        } else if ($(hash).is(selectors.container)) {
          return $(hash).find(selectors.heading).click();
        }
      };
      $(selectors.container).css("overflow", "hidden");
      toHide = $(selectors.container).not(selectors.open).find(selectors.section);
      heading = $(selectors.heading);
      toHide.hide();
      heading.css("cursor", "pointer");
      heading.click(function() {
        var parent, t;
        t = $(this);
        parent = t.parent();
        if (parent.hasClass(classNames.open)) {
          parent.removeClass(classNames.open);
          t.attr("aria-expanded", "false");
        } else {
          parent.addClass(classNames.open);
          t.attr("aria-expanded", "true");
        }
        t.next().slideToggle("fast");
        return false;
      });
      if (window.location.hash) {
        hash = window.location.hash;
        openCollapsiblesForAnchor(hash, window.location);
      }
      if (indexOf.call(window, "onhashchange") >= 0) {
        return $(window).bind("hashchange", function(e) {
          hash = window.location.hash;
          return openCollapsiblesForAnchor(hash, window.location);
        });
      }
    });
  }).call(this);
}).call(this);
